function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-sort1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "sort1",
  clipPath: "url(#clip-sort1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_12003",
  "data-name": "Group 12003",
  transform: "translate(-2970 -8588)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_10389",
  "data-name": "Group 10389",
  transform: "translate(26539.463 15892.32)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_18096",
  "data-name": "Path 18096",
  d: "M-23565.461-7294.21l3.992-4.816,3.992,4.816Z",
  transform: "translate(-0.002 -0.294)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5630",
  "data-name": "Rectangle 5630",
  width: 16,
  height: 16,
  transform: "translate(2970 8588)",
  fill: "none"
})));

var SvgSortArrowUp = function SvgSortArrowUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSortArrowUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sort-arrow-up.407908ca.svg";
export { ForwardRef as ReactComponent };